import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getGrnChargeStatus,
  getParticularPage,
  getNext,
  getPrevious,
  createGrnChargeStatus,
  updateGrnChargeStatus,
  handleSearch,
  getGrnChargeStatusById,
} from "./thunk";

const initialState = {
  grnChargeStatuss: [],
  edit: false,
  grnChargeStatus: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingGrnChargeStatus: false,
  loadingNext: false,
  showCreateModal: false,
};

export const grnChargeStatusSlice = createSlice({
  name: "grnChargeStatus",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllGrnChargeStatus: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGrnChargeStatus = false;
      state.grnChargeStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createGrnChargeStatus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createGrnChargeStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createGrnChargeStatus.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateGrnChargeStatus.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateGrnChargeStatus.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateGrnChargeStatus.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getGrnChargeStatusById.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(getGrnChargeStatusById.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = true;
      state.grnChargeStatus = action.payload.data;
    });
    builder.addCase(getGrnChargeStatusById.rejected, (state) => {
      state.loadingUpdated = false;
      state.grnChargeStatus = null;
      state.edit = false;
    });
    builder.addMatcher(
      isAnyOf(
        getGrnChargeStatus.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingGrnChargeStatus = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrnChargeStatus.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGrnChargeStatus = false;
        state.grnChargeStatuss = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrnChargeStatus.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGrnChargeStatus = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllGrnChargeStatus } = grnChargeStatusSlice.actions;

export default grnChargeStatusSlice.reducer;
